/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomToken } from '../../models/custom-token';

export interface SubmitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Params {
  org: string;
}

export function submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet(http: HttpClient, rootUrl: string, params: SubmitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomToken>> {
  const rb = new RequestBuilder(rootUrl, submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomToken>;
    })
  );
}

submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet.PATH = '/api/v2/auth/{org}/submitter/token';
